import {
  ConfigModel,
  LoggerFactory,
  Persistence,
  SessionPersistence,
  SessionStoragePersistence
} from '@ibe/services';
import { authService } from '../Hooks/Contexts';

class Store {
  token?: string;
}

const logger = LoggerFactory.get('initAuth');

export let authSession: Persistence<Store> = new SessionPersistence<Store>(Store);

export const initAuth = async (config: ConfigModel): Promise<void> => {
  logger.log('initAuth...');
  if (!config.sessionKeyTabsShared) {
    authSession = new SessionStoragePersistence<Store>(Store);
  }
  authSession.useKey(config.sessionKeyAuth);
  const data = authSession.get();
  logger.log('authSession.get()', data);
  if (data.token) {
    authService.fromJwt(data.token);
  }
};
